import api from "@/components/customAxios/Axios"
import contactUsImg from "@/assets/getInTouch.webp";
import { useToast } from "../toast";

const GetInTouch = () => {

	const toast = useToast()

	const sendMessage = async (e: any) => {
		e.preventDefault();



		const formData = new FormData(e.target); // Get form data
		const form = e.target
		// Convert FormData to an object
		const data = Object.fromEntries(formData.entries());
		const pageUrl = window.location.href;
		try {

			const response = await api.post("contact-form", {
				name: data.name,
				description: data.message,
				email: data.email,
				page_url: pageUrl
			})

			if (response.status === 200) {
				form.reset();
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Message sent",
					description:
						"We have received your message. We'll get back to you soon.",
					open: true,
				});
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "error",
				title: "Something went wrong",
				description: error.response?.data?.error || error.response?.data?.message || "Unable to send message. Please try again later.",
				open: true,
			});
		}
	};

	return (
		<div className="max-w-7xl mx-auto  py-12 mt-10">
			<div className="grid md:grid-cols-2 gap-8 items-start">

				{/* Left Section - Contact Form */}
				<div className="bg-white rounded-xl px-8">
					<h2 className="text-3xl font-bold text-gray-900 mb-4">Contact us</h2>
					<p className="text-gray-600 mb-6">
						Have any questions or need assistance with Talentick.ai? Our team is here to support you. Send us a message, and our team will get back to you within 24 hours.
					</p>

					<form className="" onSubmit={sendMessage}>
						<div className="my-6">
							<input
								required
								type="text"
								name="name"
								placeholder="Name"
								className="w-full  py-3 border-b border-gray-300 rounded focus:outline-none focus:ring-0 "
							/>

						</div>

						<div className="my-6">

							<input
								required
								type="email"
								name="email"
								placeholder="Email"
								className="w-full  py-3 border-b border-gray-300 rounded focus:outline-none focus:ring-0 "
							/>
						</div>



						<textarea
							required
							name="message"
							rows={6}
							placeholder="Message"
							className="w-full  py-3 border-b border-gray-300 rounded focus:outline-none focus:ring-0 "
						/>

						<button
							type="submit"
							className="w-full bg-black text-white text-center font-medium py-3 rounded-full mt-8 hover:scale-110 transition-all"
						>
							Get in touch
						</button>
					</form>

					<p className="mt-12 text-sm text-center ">
						Prefer email? <a href="mailto:support@talentick.ai" className="text-gray-600 underline">support@talentick.ai</a>
					</p>
				</div>

				{/* Right Section - Visual Info with Image */}
				<div className="relative rounded-xl overflow-hidden shadow-lg h-[90%] hidden md:block">
					<img
						src={contactUsImg}
						alt="Representative"
						className="object-cover w-full h-full"
					/>
					<div className="absolute inset-0  bg-opacity-40 flex flex-col justify-end p-6 text-white px-10 pb-9 bg-gradient-to-t from-slate-900 via-gray-500/5 to-zinc-50/50">
						<p className="text-base ">
							Our features are thoughtfully designed to equip you with the insights and tools needed to make confident decisions, ensure fair evaluations, and build outstanding teams.
						</p>
						{/* <p className="mt-4 font-medium">Name</p> */}
					</div>

					{/* Right Arrow */}
					{/* <div className="absolute top-4 right-4 border border-white bg-opacity-80 rounded-full p-2 cursor-pointer">
			  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
			  </svg>
			</div> */}
				</div>
			</div>
		</div>

	);
};

export default GetInTouch;
